import { translate } from 'secullum-i18n';

export const Keys = {
  DISPOSITIVO_AUTORIZADO: 'dispositivo-autorizado',
  PERMISSAO_LOCALIZACAO: 'permissao-localizacao',
  SERVICO_LOCALIZACAO: 'servico-localizacao',
  ULTIMA_LOCALIZACAO: 'ultima-localizacao',
  BUSCANDO_COORDENADAS: 'buscando-coordenadas',
  DATA_HORA_AUTOMATICA: 'data-hora-automatica',
  NOVA_INCLUSAO: 'nova-inclusao',
  ULTIMAS_BATIDAS: 'ultimas-batidas',
  LOCALIZACAO_FICTICIA: 'localizacao-ficticia',
  BUSCANDO_ENDERECO: 'buscando-endereco',
  SEM_LOCALIZACAO: 'sem-localizacao'
};

export const getMessage = (key: string) => {
  const msg = Messages.get(key);
  return msg ? translate(msg) : '';
};

const Messages = new Map<string, string>([
  [Keys.DISPOSITIVO_AUTORIZADO, 'Verificando dispositivo autorizado'],
  [Keys.PERMISSAO_LOCALIZACAO, 'Verificando permissão de localização'],
  [Keys.SERVICO_LOCALIZACAO, 'Verificando serviço localização'],
  [Keys.ULTIMA_LOCALIZACAO, 'Buscando última localização'],
  [Keys.BUSCANDO_COORDENADAS, 'Buscando coordenadas'],
  [Keys.DATA_HORA_AUTOMATICA, 'Verificando data e hora automática'],
  [Keys.NOVA_INCLUSAO, 'Carregando informações nova inclusão manual'],
  [Keys.ULTIMAS_BATIDAS, 'Carregando últimas batidas'],
  [Keys.LOCALIZACAO_FICTICIA, 'Validando localização fictícia'],
  [Keys.SEM_LOCALIZACAO, 'Sem acesso à localização']
]);
